import { render, staticRenderFns } from "./CannotDownloadLink.vue?vue&type=template&id=45dcd1cd&"
import script from "./CannotDownloadLink.vue?vue&type=script&lang=js&"
export * from "./CannotDownloadLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports